const helpContactInfo = {
  GBR: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: true,
    addressTitle: "Help.addressTitle",
  },
  DEU: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: false,
    contactEmail: "fordrls@ford.com",
  },
  NOR: {
    contactSubHeader: "Help.subheader2",
    displayContact: false,
    displayLink: false,
    displayPhone: false,
    contactEmail: "None",
  },
  FRA: {
    contactSubHeader: "Help.subheader3",
    displayContact: false,
    displayLink: true,
    displayPhone: false,
    contactLink:
      "https://www.eufmcdealer.dealerconnection.com/sites/fra/doc/Pages/New-Query.aspx",
    contactEmail: "None",
  },
  NLD: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: false,
    contactEmail: "helpbnl@ford.com",
  },
  CHE: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: false,
    contactEmail: "ecommch@ford.com",
  },
  ITA: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: false,
    contactEmail: "empita@ford.com",
  },
  CZE: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: true,
    addressTitle: "Help.addressTitle",
  },
  POL: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: true,
    addressTitle: "Help.addressTitle",
  },
  IRL: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: true,
    addressTitle: "Help.addressTitle",
  },
  HUN: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: true,
    addressTitle: "Help.addressTitle",
  },
  GRC: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: true,
    addressTitle: "Help.addressTitle",
  },
  ROU: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: true,
    addressTitle: "Help.addressTitle",
  },
  PRT: {
    contactSubHeader: "Help.subheader",
    displayContact: true,
    displayLink: false,
    displayPhone: true,
    addressTitle: "Help.addressTitle",
  },
};

export { helpContactInfo };
